module.exports = __webpack_public_path__ + "img/bg_1440_0_9998.b2acf958.png";